var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddMoreRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1689 11.1228H12.8008V3.82853C12.8008 3.43359 12.5 3.03125 11.9961 3.03125C11.5156 3.03125 11.1939 3.42969 11.1939 3.82853V11.1902H3.82852C3.34446 11.2158 2.97565 11.5659 3.00126 12.0474C3.02431 12.493 3.38287 12.784 3.82852 12.8071H11.1254V20.1715C11.151 20.6556 11.5659 21.0244 12.0474 20.9988C12.493 20.9757 12.8516 20.6171 12.8746 20.1715V12.8747H20.1715C20.6555 12.849 21.0244 12.4341 20.9987 11.9526C20.9731 11.5044 20.6171 11.1484 20.1689 11.1228Z",
    fill: "#660099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoreRegular);
export default __webpack_public_path__ + "static/media/add-more-regular.d01235142cb535b3fd30df361c514610.svg";
export { ForwardRef as ReactComponent };